var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWoTm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 17,
    viewBox: "0 0 100 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3636 0L16.3636 8.647C16.3699 13.2449 12.713 16.9809 8.18749 17C3.65757 16.9873 -0.0062704 13.2494 8.05715e-06 8.647L1.12134e-06 0H2.83698V8.647C2.83069 11.6575 5.22438 14.105 8.18749 14.1177C11.1506 14.1081 13.5468 11.6633 13.5437 8.65276V0H16.3636ZM21.9146 17V8.82324C21.9086 7.29493 22.4693 5.82674 23.4732 4.74207C24.4772 3.6574 25.842 3.04523 27.2671 3.0404C30.2281 3.05046 32.6227 5.6294 32.6195 8.805V16.9818H35.4545V8.805C35.4577 3.95024 31.7938 0.010064 27.2671 0C22.7425 0.0167625 19.0846 3.95867 19.0909 8.81108V16.9878L21.9146 17ZM52.6831 0C48.1752 0.032267 44.5391 3.8303 44.5455 8.5C44.5391 13.1697 48.1752 16.9677 52.6831 17H58.1818V14.0669H52.6831C49.7257 14.054 47.3367 11.5635 47.343 8.5C47.3398 5.43651 49.7314 2.94863 52.6888 2.93892H58.1818V0.00586531L52.6831 0ZM40.9091 17V0H38.1818V17H40.9091ZM63.6364 17V0H60.9091V17H63.6364ZM96.2465 0V1.58494C96.2528 4.6496 93.8615 7.14015 90.9034 7.14986C87.9466 7.13692 85.5572 4.64827 85.5603 1.58494V0H82.7273V1.58494C82.7301 5.70161 85.5763 9.22616 89.4869 9.9558V17H92.3199V9.9558C96.2351 9.23118 99.0871 5.70531 99.0909 1.58494V0H96.2465ZM66.3636 0V2.93103H72.1485V17H75.1242V2.93103H80.9091V0H66.3636ZM97.4215 17V15.3306H98.1818V15.1111H96.3636V15.3306H97.124V16.9601L97.4215 17ZM98.4288 17V15.3991L98.9777 16.9866H99.2041L99.7599 15.4259V16.9866H100V15.1245H99.6569L99.2041 16.424C99.1561 16.5579 99.1218 16.6584 99.1081 16.7254L99.012 16.4508L98.5592 15.1111H98.1818V16.9732L98.4288 17Z",
    fill: "url(#paint0_linear_139_27237)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_139_27237",
    x1: 0.257813,
    y1: 7.98292,
    x2: 101.258,
    y2: 7.98292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.117549,
    stopColor: "#5468AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548659,
    stopColor: "#448ED7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30ACEA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWoTm);
export default __webpack_public_path__ + "static/media/logo-wo-tm.ff0419f213c05af9d4b2eee9092fd654.svg";
export { ForwardRef as ReactComponent };